import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';


import BLComponent from '../core/_BLComponent.jsx';

export default class Auth extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1 className="text--xxl-title l-margin-bottom--xl">Authentication & Authorization</h1>
				<h2 className="text--title l-margin-bottom">Make the request with OAuth protocol parameters</h2>
				<p>All requests to BrickLink REST API require you to authenticate using OAuth 1.0 like - but simpler flow. You can authorize your requests with your credentials provided after registration.</p>
				<ul>
					<li>The parameters are sent in either the HTTP Authorization header or query part of the URL with JSON format.</li>
					<li>All parameter names and values are escaped using the <a href="http://tools.ietf.org/html/rfc3986" target="_blank">RFC3986</a> percent-encoding (%xx) mechanism.</li>
				</ul>
				<h4 className="l-margin-bottom">Prameter Details</h4>
				<table>
					<tr>
						<th>Property name</th>
						<th>Value</th>
						<th>Note</th>
					</tr>
					<tr>
						<td>oauth_version</td>
						<td>String</td>
						<td>Must be <strong>1.0</strong></td>
					</tr>
					<tr>
						<td>oauth_consumer_key</td>
						<td>String</td>
						<td>The consumer key</td>
					</tr>
					<tr>
						<td>oauth_token</td>
						<td>String</td>
						<td>The access token</td>
					</tr>
					<tr>
						<td>oauth_timestamp</td>
						<td>String</td>
						<td>The timestamp is expressed in the number of seconds since January 1, 1970 00:00:00 GMT</td>
					</tr>
					<tr>
						<td>oauth_nonce</td>
						<td>String</td>
						<td>A random string, uniquely generated for each request</td>
					</tr>
					<tr>
						<td>oauth_signature_method</td>
						<td>String</td>
						<td>Must be <strong>HMAC-SHA1</strong></td>
					</tr>
					<tr>
						<td>oauth_signature</td>
						<td>String</td>
						<td>The signature as defined in <a href="http://oauth.net/core/1.0/#signing_process" target="_blank">Signing Requests</a></td>
					</tr>
				</table>
				<h4 className="l-margin-bottom">Example</h4>
				<p>The request for the orders you received is:</p>
				<Highlight className="json">{`https://api.bricklink.com/api/store/v1/orders?direction=in

Authorization: OAuth realm="",
oauth_consumer_key="7CCDCEF257CF43D89A74A7E39BEAA1E1",
oauth_token="AC40C8C32A1748E0AE1EFA13CCCFAC3A",
oauth_signature_method="HMAC-SHA1",
oauth_signature="0IeNpR5N0kTEBURcuUMGTDPKU1c%3D",
oauth_timestamp="1191242096",
oauth_nonce="kllo9940pd9333jh",
oauth_version="1.0" `}
				</Highlight>
				<p>And if using query parameters:</p>
				<Highlight className="json">{`https://api.bricklink.com/api/store/v1/orders?direction=in&Authorization=%7B%22oauth_signature%22%3A%22KVkfRqcGuEpqN7%252F57aLZVi9lS9k%3D%22%2C%22oauth_nonce%22%3A%22flBnl2yp3vk%22%2C%22oauth_version%22%3A%221.0%22%2C%22oauth_consumer_key%22%3A%227CCDCEF257CF43D89A74A7E39BEAA1E1%22%2C%22oauth_signature_method%22%3A%22HMAC-SHA1%22%2C%22oauth_token%22%3A%22AC40C8C32A1748E0AE1EFA13CCCFAC3A%22%2C%22oauth_timestamp%22%3A%221397119302%22%7D`}</Highlight>
				<p>You can verify the signature of the request on the link below:</p>
				<ul>
					<li>Online: <a href="http://oauth.googlecode.com/svn/code/javascript/example/signature.html" target="_blank">http://oauth.googlecode.com/svn/code/javascript/example/signature.html</a></li>
					<li>Java code: <a href="//static2.bricklink.com/api/BLAuthTest.zip">BLAuthTest.zip</a></li>
				</ul>
			</section>
		);
	}
}